<script>
  import {getContext} from 'svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  export let item;

  const LG = getContext('LG');
</script>

<style>
  .card {
    border-radius: 20px;
    width: 338px;
    height: 156px;
    background: #f9f9f9;
  }
  .card + :global(.card) {
    margin-left: 20px;
  }
  .text {
    margin-right: 32px;
    width: 200px;
  }
  .card img {
    border-radius: 50%;
  }
  @media screen and (max-width: 640px) {
    .card {
      width: auto;
    }
    .card + :global(.card) {
      margin: 20px 0 0 0;
    }
    .text {
      width: 180px;
    }
  }
</style>

<div class="card df fdc jcsb p24">
  <div class="df aifs jcsb">
    <div class="text f14 fw3">{item.content}</div>
    <img width="100" height="100" src={IMAGES[item.img]} alt="" />
  </div>
  <div>
    <div class="f16 fw3">{item.name}</div>
    <div>{item.subscribers} {LG(lang.Subscribers)}</div>
  </div>
</div>
